import React from "react";
import PropTypes from "prop-types";
import withReducer from "../../../components/shared/with-reducer";
import withLayout from "../../../components/desktop/layout/component";
import UsedCarValuationContainer from "../../../components/desktop/used-car-valuation";
import ErrorHandler from "../../../components/shared/with-error-handler";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import injectableReduders from "./injectable";
import SchemaUsedCarValuation from "../../../components/shared/schema-used-car-valuation";

const UsedCarValuation = ({ history }) => {
    return (
        <React.Fragment>
            <Helmet>
                <link href={`${appUrl()}${history.location.pathname.replace(/\/$/, "")}/`} rel="canonical" />
            </Helmet>
            <SchemaUsedCarValuation />
            <div>
                <ErrorHandler>
                    <UsedCarValuationContainer />
                </ErrorHandler>
            </div>
        </React.Fragment>
    );
};

UsedCarValuation.propTypes = {
    history: PropTypes.object
};

export default withReducer(injectableReduders)(() => ({}), dispatch => ({ dispatch }))(withLayout(UsedCarValuation));
